export default __webpack_public_path__ + "static/media/Panchami2.949c5ea9.png";